import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-booking-pre-confirmation-preview',
  templateUrl: './booking-pre-confirmation-preview.component.html',
  styleUrls: ['./booking-pre-confirmation-preview.component.css']
})
export class BookingPreConfirmationPreviewComponent implements OnInit {

  htmlString!: string;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private loginService: LoginService
  ) { 
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit(): void {
    let preconfId = Number(this.route.snapshot.paramMap.get("preconfId"));
    this.httpService.getBookingPreConfirmationPreview(preconfId).subscribe(res => {
      this.htmlString = res;
    });
  }
}
